export const educationDatas = [
  {
    id: 0,
    title: "Cartoon Characters Illustrator",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_1.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_1.svg").default}
      />
    ),
    date: "1998-2005",
    location: "Milan, Italy",
    school: "Primary School",
    institute: "",
    graphicTools: ["Drawing"],
    codingTools: [],
    content: [
      "Since childhood, I've been captivated by the world of art and design. Even at a young age, I discovered my passion for drawing and comics.",
      <br key={0} />,
      <br key={1} />,
      "In my school days, I proudly held the title of 'Official DragonBall Character Drawer,' crafting illustrations that brought joy to my classmates.",
      <br key={2} />,
      <br key={3} />,
      "Today, that passion has evolved into a dedicated career in graphic design, where creativity knows no bounds.",
    ],
  },

  {
    id: 1,
    title: "Art Dreamer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_2.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_2.svg").default}
      />
    ),
    date: "2006-2011",
    location: "Milan, Italy",
    school: "High School",
    institute: "Liceo Artistico Umberto Boccioni",
    graphicTools: ["Drawing", "Painting", "First sight of Graphic Design Computer Tools"],
    codingTools: [],
    content: [
      "From my early days, I knew art was my calling. In high school, I chose the Artistic School, driven by a dream to become a comic illustrator.",
      <br key={0} />,
      <br key={1} />,
      "There, I found my tribe - a community of fellow creatives, all masters of the craft.",
      <br key={2} />,
      <br key={3} />,
      "Today, that childhood passion fuels my journey as a graphic designer, bringing in some way my artistic dreams to life. When I had to take the best decision for my career, Graphic Design was the closest path to my dreamed one.",
    ],
  },

  {
    id: 2,
    title: "Young Graphic Designer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_3.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_3.svg").default}
      />
    ),
    date: "2011-2013",
    location: "Milan, Italy",
    school: "Diploma",
    institute: "Scuola Civica Arte & Messaggio, Milan, Italy",
    graphicTools: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Adobe After Effects",],
    codingTools: [],
    content: [
      "After completing high school, my passion for graphic design led me to a hands-on Visual Design course. Eager to dive into the creative world, I embarked on this practical journey.",
      <br key={0} />,
      <br key={1} />,
      "Here, I honed my skills with Adobe Suite and essential design tools, adding a touch of web design and coding to my repertoire. This immersive experience equipped me to turn my design aspirations into impactful visual realities.",
      <br key={2} />,
      <br key={3} />,
      "Immediately after I got my Visual Design Diploma I started to work as a Graphic Designer Intern in a Advertising Agency.",
    ],
  },

  {
    id: 3,
    title: "Traveller Graphic Designer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_4.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_4.svg").default}
      />
    ),
    date: "2015 - 2016",
    location: "London, UK",
    school: "Experience Abroad",
    institute: "",
    graphicTools: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Sketch"],
    codingTools: [],
    content: [
      "From childhood doodles to challenging routines, my journey is a story of growth.",
      <br key={0} />,
      <br key={1} />,
      "As a Graphic Design Intern, I craved more than a stagnant routine. So, I ventured to London, stepping out of my comfort zone.",
      <br key={2} />,
      <br key={3} />,
      "Here, I honed my English skills, embraced discipline, and became a fitness passionate. Ambition fueled my mission: to work as a Graphic Designer in the UK. Today, I stand here, having turned aspirations into accomplishments.",
    ],
  },

  {
    id: 4,
    title: "Product Designer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_5.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_5.svg").default}
      />
    ),
    date: "2016 - Now",
    location: "Milan, Italy",
    school: "Working Experience",
    institute: "",
    graphicTools: ["Blender", "Procreate", "Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Adobe After Effects", "Sketch", "WordPress", "Elementor"],
    codingTools: ["HTML", "CSS"],
    content: [
      "After honing my skills in London, I returned to Italy eager to make an impact.",
      <br key={0} />,
      <br key={1} />,
      "My proficiency in English proved invaluable, enhancing my role and enriching my professional journey, and was just a matter of time for my expertise to found a home in the esteemed corridors of European Aerosols, where I became their trusted Product Designer. Working closely with international teams, including Area Managers and Marketing figures, I contributed significantly to projects spanning South Europe.",
      <br key={2} />,
      <br key={3} />,
      "While working full-time as a Product Designer I never stop studying and learning new skills, I built my first website in Wordpress and Elementor, I started learning animation and I started practicing coding, adding a bit of Javascript and customization to my website. I recently started practicing 3D also, discovering a fantastic world that involves me using Blender.",
    ],
  },

  {
    id: 5,
    title: "Front-End Developer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_6.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_6.svg").default}
      />
    ),
    date: "2023 - 2024",
    location: "Milan, Italy",
    school: "Self taught",
    institute: "",
    graphicTools: [],
    codingTools: ["HTML", "CSS", "Javascript", "React", "Vue", "NodeJS", "Express", "Next.js", "MongoDB", "Git"],
    content: [
      "From childhood creativity to the discovery of coding, my journey is a fusion of design and tech. After years in the design realm, my curiosity led me to the world of coding.",
      <br key={0} />,
      <br key={1} />,
      "I revitalized my HTML skills from my Visual Design Diploma, delving into courses like 'The Complete 2023 Web Development Bootcamp' by Angela Yu on Udemy and lots of practice, everyday. It took me a lot of effort, but the need of overcoming obstacles is my gasoline, so I took it as my new mission.",
      <br key={2} />,
      <br key={3} />,
      "The challenges became opportunities, and my thirst for web knowledge grew. Now, I’m certain about my career shift from Design to Coding. My design background serves as a strong foundation, ready to fuel my passion for building innovative websites and apps.",
    ],
  },
 
  {
    id: 6,
    title: "Software Developer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_7.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_7.svg").default}
      />
    ),
    date: "2024 - Now",
    location: "Milan, Italy",
    school: "Working Experience",
    institute: "",
    graphicTools: [],
  codingTools: ["Javascript", "React", "Vue", "Templating", "API", "Golang", "NodeJS", "SQL", "Python", "Linux", "Docker", "Kubernetes", "Ansible", "gRPC/Protobuf" ],
    content: [
      "I currently work at Avid Technology Italian division as a Junior Software Developer, where my professional path has fully transitioned into enterprise software development.",
      <br key={0} />,
      <br key={1} />,
      "In this role, I continue to strengthen my UI and UX skills, applying design principles to complex, production-ready applications. At the same time, I'm expanding my technical scope beyond the front end, gaining hands-on experience with back-end development, Linux-based systems, virtual machines, and containerized environments used in professional software infrastructures.",
      <br key={2} />,
      <br key={3} />,
      "This position represents a key stage in my growth as a software developer, bridging user-centered design with system-level thinking and modern development practices.",
    ],
  },

  {
    id: 7,
    title: "Full-Stack Developer",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_8.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_8.svg").default}
      />
    ),
    date: "As soon as possible",
    location: "🔒",
    institute: "",
    graphicTools: ["🔒"],
    codingTools: ["🔒"],
    content: [
      "From my early days, I’ve been on a quest for knowledge and creativity.",
      <br key={0} />,
      <br key={1} />,
      "My educational journey, woven with curiosity and determination, started as a child. Today, I stand as a dynamic designer and developer, driven by an insatiable hunger for learning.",
      <br key={2} />,
      <br key={3} />,
      "My aspirations reach beyond Front-End; I aim to delve into Back-End expertise, aspiring to become a versatile Full-Stack professional. Eager to collaborate and innovate, I bring an endless enthusiasm for growth to every endeavor.",
    ],
  },

  {
    id: 8,
    title: "God Level",
    icon: (
      <img
        alt="tool-icon-img"
        className="educationIcon"
        src={require("../assets/Education-Icon_9.svg").default}
      ></img>
    ),
    avatar: (
      <img
        alt="avatar"
        className="ItemAvatar"
        src={require("../assets/Education-Icon_9.svg").default}
      />
    ),
    date: "As soon as possible",
    location: "🔒",
    institute: "",
    graphicTools: ["🔒"],
    codingTools: ["🔒"],
    content: [
      "Embarking on my educational journey from the canvas of childhood dreams, I've woven a tapestry of curiosity, experimentation, and relentless learning.",
      <br key={0} />,
      <br key={1} />,
      "I call this stage of my path 'God Level': a playful name for a very real goal — pushing my skills as far as possible and mastering the world of Software Development, where I’ve discovered a true passion.",
      <br key={2} />,
      <br key={3} />,
      "It’s a field that naturally connects everything I love, from gaming to hardware, problem-solving, and emerging technologies like AI. Every challenge is an opportunity to level up, learn faster, and turn ideas into something real.",
    ],
  },
];
